import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { convertUrlFileToPDF } from '../../../../application/helpers/file-helper';
import { useAppDispatch } from '../../../../application/store/useStore';
import { useTranslation } from 'react-i18next';
import { alpha, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import Grid from '@mui/material/Grid2';
import { Icon } from '@iconify/react';
import { Download04Icon } from 'hugeicons-react';
export function ProposalDocumentPopUp({ openProposalDocumentDialog, proposalName, onClose, files }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const downloadPorposalDocument = (name, folderName) => {
        convertUrlFileToPDF(name, folderName, dispatch);
    };
    return (_jsxs(Dialog, { maxWidth: 'sm', fullWidth: true, sx: {
            '& .MuiDialog-paper': {
                overflow: 'hidden',
                backgroundColor: "#212B36"
            }
        }, open: openProposalDocumentDialog, onClose: onClose, children: [_jsxs(DialogTitle, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    position: 'sticky',
                    top: 0,
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    zIndex: 1000,
                    padding: '16px'
                }, children: [proposalName + ' ' + t('documents'), _jsx(IconButton, { "aria-label": 'close', onClick: onClose, sx: {
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.text.primary
                        }, children: _jsx(CloseOutlined, {}) })] }), _jsx(DialogContent, { sx: {
                    maxHeight: 'calc(100svh - 32px)',
                    overflowY: 'auto',
                    backgroundColor: theme.palette.background.paper,
                }, children: _jsx(Box, { display: 'flex', flexDirection: 'column', gap: '20px', children: _jsx(Box, { display: 'flex', flexDirection: 'column', gap: '12px', children: _jsx(Grid, { container: true, spacing: 1, children: files.map((file, index) => (_jsxs(Box, { sx: {
                                    backgroundColor: theme.palette.background.default,
                                    boxShadow: theme.customShadows.card,
                                    padding: '8px 12px',
                                    borderRadius: 1
                                }, gap: 1, width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', flex: '1 auto', children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsxs(Box, { display: 'flex', flexDirection: 'row', children: [_jsx(Icon, { icon: 'material-icon-theme:pdf', width: 40, height: 40, color: 'default' }), _jsxs(Box, { display: 'flex', flexDirection: 'column', children: [_jsx(Tooltip, { title: file.name, arrow: true, children: _jsx(Typography, { variant: 'body1', color: theme.palette.text.primary, sx: {
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    maxWidth: '200px',
                                                                    display: 'block'
                                                                }, children: file.name }) }), _jsxs(Typography, { variant: 'caption', color: theme.palette.text.secondary, children: [file.fileSize, " KB"] })] })] }) }), _jsxs(Grid, { size: { xs: 12, md: 6 }, display: 'flex', flexDirection: 'row', gap: 1, children: [_jsx(Box, { flexGrow: 1 }), _jsx(Box, { display: 'flex', alignItems: 'center', children: _jsx(IconButton, { "aria-label": 'delete', onClick: () => downloadPorposalDocument(file.name, file.folderName), sx: {
                                                        backgroundColor: alpha(theme.palette.grey[500], 0.12),
                                                        color: theme.palette.text.primary,
                                                        '&:hover': {
                                                            backgroundColor: alpha(theme.palette.grey[500], 0.24)
                                                        }
                                                    }, children: _jsx(Download04Icon, {}) }) })] })] }))) }) }) }) }), _jsx(DialogActions, { sx: {
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: theme.palette.background.paper,
                    borderTop: `1px solid ${theme.palette.divider}`,
                    zIndex: 1000,
                    padding: '16px'
                }, children: _jsx(Button, { variant: 'outlined', size: 'small', color: 'inherit', autoFocus: true, onClick: () => {
                        onClose();
                    }, children: t('cancel') }) })] }));
}
